import React, { useState, useContext, useEffect } from "react";
import { AppContext } from '../../application/provider';
import { Modal, ModalHeader, ModalBody, Button, Form, FormGroup } from 'reactstrap';
import "./ModalCrearUsuario.css";
import UsuarioService from "../../axios_services/usuarios.service";
import Loader from '../../components/Loader/Loader';
import { Briefcase, RotateCcw } from "lucide-react";

function ModalReestablecerUsuario({ isOpen }) {

    const [state, setState] = useContext(AppContext);
    const [loading, setLoading] = useState(false);
    const [fecha_ingreso, setFechaIngreso] = useState('');
    const [perfil_id, setPerfilId] = useState('');
    const [area_id, setAreaId] = useState('');
    const [perfil_id_jefe_inmediato, setPerfilIdJefeInmediato] = useState('');
    const [usuario_id_jefe_inmediato, setUsuarioIdJefeInmediato] = useState('');
    const [resetear_password, setResetearPassword] = useState(false);

    const [allUsers, setAllUsers] = useState([]);
    const [areas_laborales, setAreas] = useState([]);

    const perfilesList = state.catalogos?.perfiles || [];
    const perfilesSorted = [...perfilesList].sort((a, b) => (a.descripcion || '').localeCompare(b.descripcion || ''));

    const getPerfilesPorArea = (selectedAreaId) => {
        const id = Number(selectedAreaId);
        if (id === 1) return perfilesSorted.filter(p => [1, 2, 3, 4, 6, 23, 27, 29, 30].includes(Number(p.perfil_id)) || Number(p.area_id) === 1);
        if (id === 2) return perfilesSorted.filter(p => [5, 8, 10, 11, 12, 13, 15, 17, 18, 19, 21, 22, 24, 25, 26, 30].includes(Number(p.perfil_id)) || Number(p.area_id) === 2);
        if (id === 3) return perfilesSorted.filter(p => [7, 16, 20].includes(Number(p.perfil_id)) || Number(p.area_id) === 3);
        if (id === 4) return perfilesSorted.filter(p => [9, 14].includes(Number(p.perfil_id)) || Number(p.area_id) === 4);
        if (id === 5) return perfilesSorted.filter(p => [28].includes(Number(p.perfil_id)) || Number(p.area_id) === 5);
        return [];
    };

    useEffect(() => {
        if (state.modalReestablecerUsuario && state.usuario) {
            setFechaIngreso(new Date().toISOString().split('T')[0]);
            setPerfilId(state.usuario.perfil_id || '');
            setAreaId(state.usuario.area_id || '');
            setPerfilIdJefeInmediato(state.usuario.perfil_id_jefe_inmediato || '');
            setUsuarioIdJefeInmediato(state.usuario.usuario_id_jefe_inmediato || '');
            setResetearPassword(false);

            if (state.catalogos && state.catalogos.tipos) {
                setAreas(state.catalogos.tipos.filter(t => t.categoria_id == 22));
            }

            UsuarioService.getUsuarios().then(res => {
                const list = res.usuarios || res.data || (Array.isArray(res) ? res : []);
                const activos = list.filter(u => String(u.estado) === '1');
                setAllUsers(activos);
            }).catch(e => console.error("Error cargando lista de usuarios:", e));
        }
    }, [state.modalReestablecerUsuario, state.usuario]);

    const reestablecerUsuario = async () => {
        const hoy = new Date();
        hoy.setHours(23, 59, 59, 999);
        const fechaIngresoDate = new Date(fecha_ingreso);
        const fechaCeseDate = state.usuario.fecha_cese ? new Date(state.usuario.fecha_cese) : null;

        if (fecha_ingreso === '') {
            alert("Ingrese una fecha de ingreso");
            return;
        }
        if (fechaIngresoDate > hoy) {
            alert("La fecha de ingreso no puede ser mayor a hoy");
            return;
        }
        if (fechaCeseDate && fechaIngresoDate < fechaCeseDate) {
            alert("La fecha de ingreso debe ser igual o posterior a la fecha de cese (" + state.usuario.fecha_cese + ")");
            return;
        }

        if (!perfil_id || !area_id) {
            alert("Por favor complete los campos obligatorios de información laboral (Cargo y Área)");
            return;
        }

        try {
            setLoading(true);

            await UsuarioService.reestablecerUsuario(
                state.usuario.usuario_id,
                state.user?.usuario_id,
                fecha_ingreso,
                resetear_password,
                {
                    perfil_id,
                    area_id,
                    usuario_id_jefe_inmediato: usuario_id_jefe_inmediato || null,
                    perfil_id_jefe_inmediato: perfil_id_jefe_inmediato || null,
                    fecha_termino_contrato: null
                }
            );

            setState((prevState) => ({ ...prevState, isUpdated: true }));
            alert(
                resetear_password
                    ? "Usuario reactivado correctamente. La contraseña fue restablecida a la clave global (MEC2026!Pass). El usuario deberá cambiarla en su próximo ingreso."
                    : "Usuario reactivado correctamente. La contraseña se mantuvo sin cambios."
            );
            cerrarModal();
        } catch (error) {
            console.error("Error al reestablecer el usuario:", error);
            alert("Ocurrió un error al reestablecer el usuario. Por favor, intente nuevamente.");
        } finally {
            setLoading(false);
        }
    };

    function cerrarModal() {
        setState((prevState) => ({
            ...prevState,
            modalReestablecerUsuario: false,
            usuario: null
        }));
        setFechaIngreso('');
        setPerfilId('');
        setAreaId('');
        setPerfilIdJefeInmediato('');
        setUsuarioIdJefeInmediato('');
        setResetearPassword(false);
    };

    return (
        state.modalReestablecerUsuario === true && (
            <Modal isOpen={state.modalReestablecerUsuario} className="custom-modal" backdrop={true}>
                <ModalHeader className="modal-header">
                    <div className="titulo">
                        <h1>{`${state.usuario?.apellidos?.toUpperCase()}, ${state.usuario?.nombre?.toUpperCase()}`}</h1>
                        <Button className="close-btn" onClick={cerrarModal}>X</Button>
                    </div>
                </ModalHeader>
                <div className="modal-body-footer">
                    {loading ? (
                        <Loader />
                    ) : (
                        <ModalBody className="modal-body">
                            <Form className="fila">
                                <fieldset className="fieldset-container">
                                    <legend className="fieldset-legend">
                                        <Briefcase size={18} style={{ marginRight: '0.5rem' }} />
                                        Información laboral
                                    </legend>

                                    <FormGroup className="form-group">
                                        <label>Área (*):</label>
                                        <select
                                            className="form-control small-input"
                                            name="area_id"
                                            value={area_id}
                                            onChange={(e) => {
                                                setAreaId(e.target.value);
                                                setPerfilId('');
                                                setPerfilIdJefeInmediato('');
                                                setUsuarioIdJefeInmediato('');
                                            }}
                                        >
                                            <option value="">Seleccione el área laboral</option>
                                            {areas_laborales.map((item) => (
                                                <option key={item.tipo_id} value={item.tipo_id}>
                                                    {item.descripcion}
                                                </option>
                                            ))}
                                        </select>
                                    </FormGroup>

                                    <FormGroup className="form-group">
                                        <label>Cargo (*):</label>
                                        <select
                                            className="form-control small-input"
                                            name="perfil_id"
                                            value={perfil_id}
                                            onChange={(e) => {
                                                setPerfilId(e.target.value);
                                            }}
                                        >
                                            <option value="">Seleccione el cargo</option>
                                            {getPerfilesPorArea(area_id).map((perfil) => (
                                                <option key={perfil.perfil_id} value={perfil.perfil_id}>
                                                    {perfil.descripcion}
                                                </option>
                                            ))}
                                        </select>
                                    </FormGroup>

                                    <FormGroup className="form-group">
                                        <label>Cargo del Jefe Inmediato:</label>
                                        <select
                                            className="form-control small-input"
                                            name="perfil_id_jefe_inmediato"
                                            value={perfil_id_jefe_inmediato}
                                            onChange={(e) => {
                                                setPerfilIdJefeInmediato(e.target.value);
                                                setUsuarioIdJefeInmediato('');
                                            }}
                                        >
                                            <option value="">Seleccione cargo</option>
                                            {perfilesSorted.map((item) => (
                                                <option key={item.perfil_id} value={item.perfil_id}>
                                                    {item.descripcion}
                                                </option>
                                            ))}
                                        </select>
                                    </FormGroup>

                                    <FormGroup className="form-group">
                                        <label>Jefe inmediato (*):</label>
                                        <select
                                            className="form-control small-input"
                                            name="usuario_id_jefe_inmediato"
                                            value={usuario_id_jefe_inmediato}
                                            onChange={(e) => setUsuarioIdJefeInmediato(e.target.value)}
                                            disabled={!perfil_id_jefe_inmediato}
                                        >
                                            <option value="">Seleccione el jefe</option>
                                            {(allUsers.length > 0 ? allUsers : (state.jefes_inmediatos || []))
                                                .filter(u => Number(u.perfil_id) === Number(perfil_id_jefe_inmediato))
                                                .sort((a, b) => `${a.apellidos || ''}, ${a.nombre || ''}`.localeCompare(`${b.apellidos || ''}, ${b.nombre || ''}`))
                                                .map((item) => (
                                                    <option key={item.usuario_id} value={item.usuario_id}>
                                                        {item.apellidos}, {item.nombre}
                                                    </option>
                                                ))}
                                        </select>
                                    </FormGroup>

                                    <FormGroup className="form-group">
                                        <label>Fecha de ingreso:</label>
                                        <input
                                            className="form-control small-input"
                                            name="fecha_ingreso"
                                            type="date"
                                            value={fecha_ingreso}
                                            onChange={(e) => setFechaIngreso(e.target.value)}
                                            min={state.usuario?.fecha_cese || undefined}
                                            max={new Date().toISOString().split('T')[0]}
                                        />
                                    </FormGroup>
                                </fieldset>

                                <fieldset className="fieldset-container">
                                    <legend className="fieldset-legend">
                                        <RotateCcw size={18} style={{ marginRight: '0.5rem' }} />
                                        Seguridad
                                    </legend>
                                    <FormGroup className="form-group">
                                        <label style={{ fontWeight: '600', marginBottom: '0.5rem', display: 'block' }}>
                                            ¿Desea restablecer la contraseña?
                                        </label>
                                        <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
                                            <label style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', cursor: 'pointer', fontWeight: 'normal' }}>
                                                <input
                                                    type="radio"
                                                    name="opcion_password"
                                                    checked={!resetear_password}
                                                    onChange={() => setResetearPassword(false)}
                                                />
                                                Mantener contraseña actual
                                            </label>
                                            <label style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', cursor: 'pointer', fontWeight: 'normal' }}>
                                                <input
                                                    type="radio"
                                                    name="opcion_password"
                                                    checked={resetear_password}
                                                    onChange={() => setResetearPassword(true)}
                                                />
                                                Restablecer a (MEC2026!Pass)
                                            </label>
                                        </div>
                                    </FormGroup>
                                </fieldset>

                                <div className="button-container">
                                    <Button
                                        id="boton-form-modal"
                                        className="button-custom"
                                        style={{ backgroundColor: '#2e7d32' }}
                                        onClick={async () => {
                                            const confirmAction = window.confirm("¿Está seguro de que desea reactivar a este usuario?");
                                            if (!confirmAction) {
                                                return;
                                            }
                                            await reestablecerUsuario();
                                        }}
                                    >
                                        {"REACTIVAR USUARIO"}
                                    </Button>
                                </div>
                            </Form>
                        </ModalBody>
                    )}
                </div>
            </Modal>
        )
    );
}

export default ModalReestablecerUsuario;